import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
export const HomePage = () => {
  return <>
      <HeroSection data-id="element-252" />
      <FeaturesSection data-id="element-253" />
      <TestimonialsSection data-id="element-254" />
      <CTASection data-id="element-255" />
    </>;
};